import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { first } from 'rxjs/operators';

import { appInject } from 'src/app/app-injector';
import { UsercentricsCmpV2Service } from 'src/app/core/services/consent/usercentrics-cmp-v2.service';
import { LazyComponentId } from 'src/app/core/services/lazy-components/lazy-components-registry';

import { LazyHostComponent } from '../../core/lazy-host/lazy-host.component';

@Component({
  selector: 'cc-consent-container',
  templateUrl: './consent-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LazyHostComponent]
})
export class ConsentContainerComponent implements OnInit {
  public componentId: LazyComponentId | null = null;

  public constructor(
    private readonly usercentricsCmpV2Service: UsercentricsCmpV2Service,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  public ngOnInit(): void {
    this.usercentricsCmpV2Service
      .activateConsentLayer()
      .pipe(first(), takeUntilDestroyed(appInject(DestroyRef)))
      .subscribe(() => {
        this.componentId = LazyComponentId.ConsentSystem;
        this.changeDetectorRef.markForCheck();
      });
  }
}
